import { filter } from 'lodash'
import React, { useEffect, useState, useCallback, useRef } from 'react'
// import { Icon } from '@iconify/react';
// import plusFill from '@iconify/icons-eva/plus-fill';
// import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  // Button,
  Checkbox,
  TableRow,
  TableBody,
  TableHead,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Button,
  IconButton,
  Modal,
  Fade,
  Box,
  Grid,
  Paper,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  CircularProgress
} from '@material-ui/core'
import CloseIcon from '@mui/icons-material/Close';
import AppBar from "@mui/material/AppBar";
// components
import Page from '../components/Page'
import Label from '../components/Label'
import Scrollbar from '../components/Scrollbar'
import SearchNotFound from '../components/SearchNotFound'
import { UserListHead, UserListToolbar, UserMoreMenuArchive } from '../components/_dashboard/user'
import OtpInput from 'react-otp-input';
import QrReader from 'react-qr-reader'
import AddIcon from '@mui/icons-material/Add';

import userAPI from 'utils/api/users'
import { logSuccessAction, ACTION_CATEGORIES } from 'utils/actionLogger'
import storage from 'utils/storage'
import Bugsnag from '@bugsnag/js'

const moment = require('moment-timezone')
moment().tz('Asia/Manila').format()
const current_date = `${moment().tz('Asia/Manila').toISOString(true)}`
const TABLE_HEAD = [
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'email', label: 'Email address', alignRight: false },
  { id: 'company', label: 'Company', alignRight: false },
  { id: 'phone', label: 'Phone', alignRight: false },
  { id: 'role', label: 'Role', alignRight: false },
  { id: 'isVerified', label: 'Verified', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: '' },
]

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1
  }
  if (b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

function applySortFilter(array, comparator, query) {
  // Return empty array if array is null or undefined to prevent errors
  if (!array) return [];
  
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })

  if (query) {
    // Use a safer approach for filtering to avoid "Cannot read property 'filter' of undefined"
    return filter(array || [], (_user) => {
      // Handle case where _user.displayName might be undefined
      const displayName = _user?.displayName || '';
      return displayName.toLowerCase().indexOf(query.toLowerCase()) !== -1;
    });
  }
  return stabilizedThis.map((el) => el[0])
}

const maskEmail = (email) => {
  if (!email) return '';
  const parts = email.split('@');
  if (parts.length !== 2) return email; // Not a valid email format or no @ sign

  const localPart = parts[0];
  const domain = parts[1];

  if (!localPart || !domain) return email; // Should be caught by parts.length check too

  let prefix;
  if (localPart.length <= 1) { // e.g., "a"
    prefix = localPart; // shows "a"
  } else if (localPart.length === 2) { // e.g., "ab"
    prefix = localPart.substring(0, 1); // shows "a"
  } else if (localPart.length === 3) { // e.g., "abc"
    prefix = localPart.substring(0, 2); // shows "ab"
  } else { // localPart.length > 3, e.g., "example", "sparklestarinternationaladm"
    prefix = localPart.substring(0, 3); // shows "exa", "spa"
  }
  const maskedLocalPart = prefix + '***';
  return `${maskedLocalPart}@${domain}`;
};

export default function TimeAdjustment() {
  const [page, setPage] = useState(0)
  const [order, setOrder] = useState('asc')
  const [selected, setSelected] = useState([])
  const [logs, setLogs] = useState([])
  const [orderBy, setOrderBy] = useState('name')
  const [filterName, setFilterName] = useState('')
  const [recordId, setRecordId] = useState('')
  const [password, setPassword] = useState('')
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const [users, setUsers] = useState([])
  const [allUsersForCurrentContext, setAllUsersForCurrentContext] = useState([]);
  const [user, setUser] = useState()
  const [doneAction, setDoneAction] = useState('')
  const [passwordDialog, setPasswordDialog] = useState(true)
  const [isValidated, setIsValidated] = useState(false)
  const [isOtpValid, setIsOtpValid] = useState(false)
  const [open, setOpen] = useState(false)
  const [otp, setOtp] = useState('')
  const [company, setCompany] = useState([])
  const [selectedCompany, setSelectedCompany] = useState()
  const [count, setCount] = useState()
  const [isLoading, setLoading] = useState(false)
  const d = new Date();
  const [date, setDate] = useState(d.setDate(d.getDate() - 1))
  const [openQR, setOpenQR] = useState(false)
  const axios = require('axios');
  
  // OTP resend / cooldown states
  const [canResendOtp, setCanResendOtp] = useState(false)
  const [cooldown, setCooldown] = useState(60)
  const [isSendingOtp, setIsSendingOtp] = useState(false)
  
  // --- OTP Cool-down Handling -------------------------------------------
  const OTP_COOLDOWN_SECONDS = 60; // 1 minute
  
  const startCooldown = (duration = OTP_COOLDOWN_SECONDS) => {
    const expiry = Date.now() + duration * 1000;
    localStorage.setItem('timeadjustment_otp_expiry', String(expiry));
    setCanResendOtp(false);
    setCooldown(duration);
  };
  
  // Global interval to keep cooldown in sync with persisted expiry time
  useEffect(() => {
    const interval = setInterval(() => {
      const expiryRaw = localStorage.getItem('timeadjustment_otp_expiry');
      if (!expiryRaw) {
        // No expiry stored – ensure resend is enabled and cooldown is 0
        setCooldown(0);
        setCanResendOtp(true);
        return;
      }

      const expiry = parseInt(expiryRaw, 10);
      const remaining = Math.max(0, Math.floor((expiry - Date.now()) / 1000));

      setCooldown(remaining);

      if (remaining === 0) {
        setCanResendOtp(true);
        localStorage.removeItem('timeadjustment_otp_expiry');
      } else {
        setCanResendOtp(false);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);
  
  // Refs to ensure once-only behaviour in development (React 18 StrictMode double render)
  const hasRequestedOtpRef = useRef(false);
  const userLoadedRef = useRef(false);
  
  const fetchDataForCurrentContext = async (companyOverride = null) => {
    setLoading(true);
    if (!user) {
      console.warn("User not loaded yet, cannot fetch data.");
      setLoading(false);
      return;
    }

    let companyToLoad = null;
    if (companyOverride) {
      companyToLoad = companyOverride;
    } else if (user.role >= 3) {
      companyToLoad = selectedCompany || (company.length > 0 ? company[0] : null) ; // Use selected or first in list if admin
    } else {
      companyToLoad = user.company;
    }

    if (companyToLoad) {
      let result;
      result = await userAPI.get_limited_usersV3(companyToLoad, 'all');
      
      if (result && result.ok && result.data) {
        const usersArray = Array.isArray(result.data) ? result.data : (result.data.data || []); // Handle different API response structures
        setUsers(usersArray);
        setAllUsersForCurrentContext(usersArray);
        if (typeof result.data.count === 'number') {
          setCount(result.data.count);
        } else {
          setCount(usersArray.length);
        }
      } else {
        Bugsnag.notify(result || new Error("Failed to fetch data in fetchDataForCurrentContext"));
        setUsers([]);
        setAllUsersForCurrentContext([]);
        setCount(0);
      }
    } else {
      // This case might happen if an admin hasn't selected a store yet and there's no default.
      console.warn("TimeAdjustment: Company not determined for fetching data.");
      setUsers([]);
      setAllUsersForCurrentContext([]);
      setCount(0);
    }
    setLoading(false);
  };
  
  const handleChangeOtp = async () => {
    const data = { email: user.email, token: otp }
    const verifyResult = await userAPI.post_timeAdjustment_otpVerify(data)
    if (verifyResult.data.success) {
      setIsOtpValid(true)
      // Clear any existing cooldown and allow immediate resend after successful verification
      localStorage.removeItem('timeadjustment_otp_expiry')
      setCooldown(0)
      setCanResendOtp(true)
      setOtp('') // Clear OTP input
      window.alert("OTP Verified")
      
      // Fetch data after successful OTP verification
      await fetchDataForCurrentContext(selectedCompany)
      logSuccessAction({
        user: user._id,
        company: user.role >= 3 ? selectedCompany : user.company,
        userDisplay: {
          name: user.displayName,
          email: user.email,
        },
        role: user.role,
        action: 'Verified OTP',
        category: ACTION_CATEGORIES.AUTHENTICATION,
        details: 'Successfully verified OTP for Time Adjustment.'
      });
    } else {
      window.alert("Invalid Code")
    }
  }

  // Helper responsible for requesting an OTP and handling cooldown logic
  const sendOtp = useCallback(async () => {
    if (!user || !canResendOtp || cooldown > 0 || isSendingOtp) return;

    setIsSendingOtp(true);
    try {
      // Immediately disable further resends and start cooldown
      startCooldown();

      const otpData = { email: user.email };
      await userAPI.get_timeAdjustment_otp(otpData);
    } catch (err) {
      console.error('Error sending OTP', err);
      Bugsnag.notify(err);
      // Re-enable resend if sending fails so the user can retry immediately
      localStorage.removeItem('timeadjustment_otp_expiry');
      setCanResendOtp(true);
      setCooldown(0);
    } finally {
      setIsSendingOtp(false);
    }
  }, [user, canResendOtp, cooldown, isSendingOtp]);

  useEffect(() => {
    const load = async () => {
      const local_user = await storage.getUser()
      if (!local_user) return
      const parsedUser = JSON.parse(local_user)
      // Only set user once to avoid triggering downstream effects twice
      if (!userLoadedRef.current) {
        setUser(parsedUser);
        userLoadedRef.current = true;
      }

      // Group store integration for admin users (role >= 3)
      if (parsedUser && parsedUser.role >= 3) {
        try {
          const storesRes = await userAPI.get_group_store(parsedUser._id);
          if (storesRes && storesRes.status === 200 && storesRes.data?.report?.store) {
            const stores = storesRes.data.report.store;
            setCompany(stores);
            const firstStore = stores[0];
            setSelectedCompany(firstStore);
            await fetchDataForCurrentContext(firstStore);
          } else {
            // If no group stores returned, fall back to user's own company
            await fetchDataForCurrentContext();
          }
        } catch (err) {
          console.error('Error fetching group stores', err);
          Bugsnag.notify(err);
          await fetchDataForCurrentContext();
        }
      } else {
        // Non-admin users or if no group stores
        await fetchDataForCurrentContext();
      }

      // Initial OTP request moved to dedicated effect below to avoid duplicate calls
    }

    load()
  }, [doneAction]) // Removed user dependencies to prevent double invocation on mount

  // Request OTP exactly once after the user object becomes available (guards against StrictMode double calls)
  useEffect(() => {
    if (user && !hasRequestedOtpRef.current && cooldown === 0 && canResendOtp) {
      sendOtp()
      hasRequestedOtpRef.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, cooldown, canResendOtp]);

  useEffect(() => {
    if (selectedCompany) {
      fetchDataForCurrentContext(selectedCompany);
    }
  }, [selectedCompany])

  // Fetch data when OTP verification is successful
  useEffect(() => {
    if (isOtpValid && user) {
      fetchDataForCurrentContext(selectedCompany);
    }
  }, [isOtpValid, user, selectedCompany])

  const handleClosePasswordDialog = () => {
    setPasswordDialog(false)
  }

  const handleGeneratePassword = async () => {
    const result = await userAPI.create_new_password()
    alert("New Password:" + result.data.password)
  }

  const handleValidatePassword = async () => {
    if (password === null || password === "") {
      alert("Please input password")
    }
    else {
      const data = {
        email: user.email,
        password: password
      }
      const result = await userAPI.verify_password(data)
      if (result.status === 200) {
        alert("Password Verified")
        setIsValidated(true)
      }
      else {
        alert("Invalid Password")
        setIsValidated(false)
      }
    }


  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }

  const handleOpen = async () => {
    const result = await userAPI.get_account_logs(user._id);
    setLogs(result.data)
    setOpen(true);
  }
  const handleClose = () => setOpen(false);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = users.map((n) => n.name)
      setSelected(newSelecteds)
      return
    }
    setSelected([])
  }

  const renderTime = (_time) => {
    let _date = new Date(_time)
    var hours = _date.getHours()
    var minutes = _date.getMinutes()
    var ampm = hours >= 12 ? 'pm' : 'am'
    hours = hours % 12
    hours = hours ? hours : 12 // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes
    var strTime = hours + ':' + minutes + ' ' + ampm
    return strTime
  }

  const filterByStatus = (_data, type) => {
    let _d = _data.filter((_d) => (_d.status === type ? _d : ''))
    if (_d.length > 0) {
      _d = _d[0]
    }
    if (_d) {
      if (typeof (_d.time) === "string") {
        return {
          time: _d.time === undefined ? 'n/a' : _d.time,
          location: _d.address === undefined ? 'n/a' : _d.address,
          workmate: _d.workmate === undefined ? '' : 'Workmate( ' + _d.workmate + ' )'
        }
      }
      else {
        return {
          time: _d.time === undefined ? 'n/a' : renderTime(_d.time),
          location: _d.address === undefined ? 'n/a' : _d.address,
          workmate: _d.workmate === undefined ? '' : 'Workmate( ' + _d.workmate + ' )'
        }
      }
    } else {
      return '-'
    }
  }

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name)
    let newSelected = []
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1))
    }
    setSelected(newSelected)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleFilterByName = (event) => {
    setFilterName(event.target.value)
  }

  const handleSearch = (e) => {
    const searchTerm = e.target.value;
    setRecordId(searchTerm);

    if (searchTerm.trim() === "") {
      // If search is cleared, revert to the full list for the current context
      setUsers(allUsersForCurrentContext);
    } else {
      // Filter the allUsersForCurrentContext list based on the ID
      const filtered = allUsersForCurrentContext.filter(userDoc =>
        userDoc._id && userDoc._id.toLowerCase().includes(searchTerm.toLowerCase()) ||
        userDoc.email && userDoc.email.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setUsers(filtered);
    }
  };

  const handleSearchButtonClick = async () => {
    if (!recordId || recordId.trim() === "") {
      alert("Please enter a Process ID or Email to search");
      return;
    }
    
    setLoading(true);
    try {
      let searchCompany = user.company;
      if (user.role >= 3 && selectedCompany) {
        searchCompany = selectedCompany;
      }
      const result = await userAPI.get_limited_usersV3(searchCompany, recordId);
      
      // First check if we have a successful response
      if (!result || result.success === false) {
        // Handle error from the backend
        const errorMsg = result && result.msg ? result.msg : "Error searching for record";
        alert(errorMsg);
        setUsers([]);
        setAllUsersForCurrentContext([]);
        setCount(0);
        console.error("Search error:", errorMsg);
        setLoading(false);
        return;
      }
      
      // Make sure to set users to an empty array by default
      let dataArray = [];
      
      if (result.data) {
        // Handle different response formats
        if (Array.isArray(result.data)) {
          dataArray = result.data;
        } else if (result.data.data && Array.isArray(result.data.data)) {
          dataArray = result.data.data;
        } else if (result.data) {
          // If it's a single object, wrap it in an array
          dataArray = [result.data];
        }
        
        // Set users and count only if we have valid data
        if (dataArray.length > 0) {
          setUsers(dataArray);
          setAllUsersForCurrentContext(dataArray); // Update this as well to keep them in sync
          setCount(dataArray.length);
        } else {
          alert("No record found with the specified ID/Email");
          setUsers([]);
          setAllUsersForCurrentContext([]); // Keep these in sync
          setCount(0);
        }
      } else {
        alert("No record found with the specified ID/Email");
        setUsers([]);
        setAllUsersForCurrentContext([]); // Keep these in sync
        setCount(0);
      }
    } catch (error) {
      Bugsnag.notify(error);
      alert("Error searching for record: " + (error.message || "Unknown error"));
      console.error("Error searching for record:", error);
      setUsers([]);
      setAllUsersForCurrentContext([]); // Keep these in sync
      setCount(0);
    } finally {
      setLoading(false);
    }
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - (users?.length || 0)) : 0

  // Ensure users is an array before applying sort and filter
  const filteredUsers = Array.isArray(users) ? applySortFilter(users, getComparator(order, orderBy), filterName) : []

  // Fixed: Changed variable name to avoid duplicate declaration
  const noUsersFound = !filteredUsers || filteredUsers.length === 0

  const checkIfDone = (action) => {
    setDoneAction(action)
  }

  const handleStoreChange = async (e) => {
    setLoading(true) // Keep loading true for the whole process
    const companyId = e.target.value;
    setSelectedCompany(companyId);
    // recordId is the search term, clear it when store changes
    setRecordId(""); // Clear search when store changes
    await fetchDataForCurrentContext(companyId);
    setLoading(false) // setLoading is handled by fetchDataForCurrentContext
  }

  const handleOpenQRModal = async () => {
    setOpenQR(true)
  }

  const handleCloseQR = () => {
    setOpenQR(false)
  }

  const handleError = (err) => {
    alert(err)
  }

  const handleScan = async (res) => {
    const url = new URL(res);
    const pathSegments = url.pathname.split("/");
    const id = pathSegments[1];
    const data = {
      "uid": user._id,
      "storeid": id
    }
    if (res) {
      const result = await userAPI.post_group_store(data)
      if (result.status === 200) {
        // load()
        setOpenQR(false)
        alert("Success")
      }
      else {
        alert("Something went wrong please try again later!")
      }
    } else {
      alert("No link found in the response.");
    }
  };

  return (
    <>
      {!isOtpValid ? (
        <Dialog open={passwordDialog}>
          <AppBar sx={{ position: "relative" }}>
            <DialogTitle id="alert-dialog-title">
              Time Adjustment!
              <IconButton
                aria-label="close"
                onClick={handleClosePasswordDialog}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
          </AppBar>
          <DialogContent>
            We sent an OTP to your email account, please input OTP.
            <br />
            <br />
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <OtpInput
                value={otp}
                onChange={setOtp}
                numInputs={6}
                renderSeparator={<span>-</span>}
                renderInput={(props) => <input {...props}
                  style={{
                    width: '40px',
                    height: '40px',
                    fontSize: '16px',
                    margin: '0 5px',
                    padding: '5px',
                    textAlign: 'center',
                  }}
                />}
              />
              <Button sx={{ ml: 3, mt: 5 }} variant="contained" onClick={handleChangeOtp}>
                Submit OTP
              </Button>
              <Button
                sx={{ ml: 2, mt: 5 }}
                variant="outlined"
                onClick={sendOtp}
                disabled={!canResendOtp || isSendingOtp}
              >
                {isSendingOtp ? (
                  <CircularProgress size={20} />
                ) : canResendOtp ? (
                  'Resend OTP'
                ) : (
                  `Resend in ${cooldown}s`
                )}
              </Button>
            </Box>
            <br />
          </DialogContent>
        </Dialog>
      ) : (
        <Page title="User Archive | Time In">
          <Container>
            <Card>

              <Scrollbar>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    {user && user.role >= 3 && (
                      <FormControl sx={{ mt: 4, ml: 3, width: "85%" }}>
                        <InputLabel id="store-select-label">Store</InputLabel>
                        <Box display="flex" alignItems="center">
                          <Select
                            labelId="store-select-label"
                            id="store-select"
                            value={selectedCompany || company[0] || ''}
                            label="Store"
                            onChange={handleStoreChange}
                            sx={{ flexGrow: 1 }} // Ensures Select takes remaining space
                          >
                           {company.slice().sort((a, b) => a.trim().replace(/\s+/g, ' ').localeCompare(b.trim().replace(/\s+/g, ' '))).map((item) => (
                                <MenuItem key={item} value={item}>
                                  {item}
                                </MenuItem>
                            ))}
                          </Select>
                          <IconButton color="primary" aria-label="add store" onClick={handleOpenQRModal} sx={{ ml: 1 }}>
                            <AddIcon />
                          </IconButton>
                        </Box>
                      </FormControl>
                    )}
                  </Grid>
                  <Grid item>
                    <Box
                      sx={{ display: 'flex', alignItems: 'center', m: 3 }}
                    >
                      <TextField
                       sx={{ width: { xs: '100%', sm: '300px' } }} // Set a smaller width for the search bar
                        id="outlined-basic"
                        value={recordId}
                        onChange={handleSearch}
                        label="Search by ID or Email"
                        variant="outlined"
                        placeholder="Type to filter, press Search for server query"
                      />
                      <Button
                        variant="contained"
                        onClick={handleSearchButtonClick}
                        disabled={isLoading}
                        sx={{ alignItems: 'end', height: "150%", width: "auto", marginLeft: "10px" }}
                      >
                        Search
                      </Button>
                      <Button
                        sx={{ alignItems: 'end' }}
                        style={{ height: "150%", width: "auto", marginLeft: "10px" }}
                        variant="contained"
                        onClick={handleOpen}
                      >
                        Logs
                      </Button>
                      <Button
                        sx={{ alignItems: 'end', height: "150%", width: "auto", marginLeft: "10px" }}
                        variant="contained"
                        onClick={() => fetchDataForCurrentContext(selectedCompany)}
                        disabled={isLoading}
                      >
                        Refresh
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
                <TableContainer component={Paper}>
                  <Table sx={{ width: "100%", minWidth: 1000 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>Proccess ID</TableCell>
                        <TableCell align="left">Email</TableCell>
                        <TableCell align="right">Date</TableCell>
                        <TableCell align="right">Time-in</TableCell>
                        <TableCell align="right">Break-in</TableCell>
                        <TableCell align="right">Break-out</TableCell>
                        <TableCell align="right">Time-out</TableCell>
                        <TableCell align="right">Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {isLoading ? (
                        <TableRow>
                          <TableCell colSpan={8} align="center">
                            <CircularProgress size={24} />
                          </TableCell>
                        </TableRow>
                      ) : Array.isArray(users) && users.length > 0 ? (
                        <>
                          {users.map((row, index) => (
                            <TableRow
                              key={row._id || `row-${index}`}
                              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                              <TableCell component="th" scope="row">
                                {row._id}
                              </TableCell>
                              <TableCell align="left">{maskEmail(row.email)}</TableCell>
                              <TableCell align="right">{moment(row.date).format('MMMM-DD-YYYY')}</TableCell>
                              <TableCell align="right">{filterByStatus(row.record || [], 'time-in').time + " - " + filterByStatus(row.record || [], 'time-in').workmate}</TableCell>
                              <TableCell align="right">{filterByStatus(row.record || [], 'break-in').time + " - " + filterByStatus(row.record || [], 'break-in').workmate}</TableCell>
                              <TableCell align="right">{filterByStatus(row.record || [], 'break-out').time + " - " + filterByStatus(row.record || [], 'break-out').workmate}</TableCell>
                              <TableCell align="right">{filterByStatus(row.record || [], 'time-out').time + " - " + filterByStatus(row.record || [], 'time-out').workmate}</TableCell>
                              <TableCell align="right"><UserMoreMenuArchive id={row._id} action={checkIfDone} data={row} /></TableCell>
                            </TableRow>
                          ))}
                        </>
                      ) : (
                        <TableRow>
                          <TableCell colSpan={8} align="center">
                            No records found
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Scrollbar>
            </Card>
          </Container>
        </Page>
      )}
      <Dialog 
        open={open} 
        onClose={handleClose} 
        fullWidth 
        maxWidth={false}
        PaperProps={{
          sx: {
            width: '80%', // Adjust to desired width
            height: '80%', // Adjust to desired height
            maxWidth: 'none', // Ensures it doesn't shrink based on `maxWidth`
          },
        }}
      >
        <DialogTitle>Time adjustment logs</DialogTitle>
        <DialogContent>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 1000}} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Email</TableCell>
                  <TableCell align="right">Name</TableCell>
                  <TableCell align="right">Processid</TableCell>
                  <TableCell align="right">Description</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {logs.length > 0
                  ?
                  <>
                    {logs.map((row) => (
                      <TableRow
                        key={row._id}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell component="th" scope="row">
                          {row.email}
                        </TableCell>
                        <TableCell align="right">{row.name}</TableCell>
                        <TableCell align="right">{row.processid}</TableCell>
                        <TableCell align="right">{row.description}</TableCell>
                      </TableRow>
                    ))}
                  </>
                  :
                  ''
                }
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openQR} onClose={handleCloseQR}>
        <DialogTitle>Scan store QR code.
          <IconButton
            aria-label="close"
            onClick={handleCloseQR}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle >
        <DialogContent>
          <>
            <QrReader
              delay={3000}
              onError={handleError}
              onScan={handleScan}
              // chooseDeviceId={()=>selected}
              style={{ width: '250px', heigth: '200px' }}
            // className={'qrScanner'}
            />
            {/*<DialogTitle style={{ display: "flex", justifyContent: "center" }}><a href="https://www.sparkletimekeeping.com/store/create">Register store account</a></DialogTitle>*/}
          </>
        </DialogContent>
      </Dialog>
    </>
  )
}